import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import HelpTip from './HelpTip';

interface Props {
  label: string;
  value: string;
  help?: React.ReactNode;
  incomplete?: boolean;
}

const HeroMetricCard: React.FC<Props> = ({ label, value, help, incomplete }) => (
  <Box
    data-testid="hero-metric-card"
    sx={{
      p: { xs: 2.5, md: 3 },
      bgcolor: 'background.paper',
      color: 'text.primary',
      borderRadius: 2,
      border: '2px solid',
      borderColor: incomplete
        ? 'warning.main'
        : (theme) => (theme.palette.mode === 'dark' ? theme.palette.brand.yellow : theme.palette.brand.navy),
      height: '100%',
      boxShadow: 1,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600 }}>
        {label}
      </Typography>
      {help && <HelpTip label={`About ${label}`}>{help}</HelpTip>}
      {incomplete && (
        <Chip
          size="small"
          label="Incomplete inputs"
          variant="outlined"
          color="warning"
          sx={{ height: 22, fontSize: 11 }}
        />
      )}
    </Box>
    <Typography
      variant="h4"
      component="p"
      color="text.primary"
      sx={{ fontWeight: 800, fontSize: { xs: '1.75rem', md: '2.125rem' }, lineHeight: 1.2 }}
    >
      {value}
    </Typography>
  </Box>
);

export default HeroMetricCard;
